export default "/assets/Icon/Bell.svg"